import { formatEuro } from "../../client/dashboard/pricingCalculator";

export { formatEuro };

export function normalizeCasePricing(raw) {
  if (!raw) return null;
  const lines = Array.isArray(raw.lines) ? raw.lines : [];
  return {
    billingPlan: raw.billing_plan || "free_tier",
    tierLabel: raw.pricing_tier_label || "",
    pricePerReview: Number(raw.price_per_review) || 0,
    caseTotal: Number(raw.case_total) || 0,
    freeReviewsApplied: raw.free_reviews_applied ?? 0,
    paidReviewCount: raw.paid_review_count ?? 0,
    reviewCount: raw.review_count ?? lines.length,
    currency: raw.currency || "EUR",
    lines: lines.map((line) => ({
      reviewId: line.review_id,
      unitPrice: Number(line.unit_price) || 0,
      lineTotal: Number(line.line_total) || 0,
      isFree: Boolean(line.is_free),
    })),
    isEstimated: Boolean(raw.is_estimated),
    monthlySubscription: raw.monthly_subscription ?? null,
  };
}

/** Attach unit_price / line_total from pricing lines onto review items. */
export function mergeReviewItemsWithPricing(items, pricing) {
  if (!pricing?.lines?.length) return items;
  const byReviewId = new Map(
    pricing.lines.map((l) => [l.reviewId, l])
  );
  return items.map((item) => {
    const line = byReviewId.get(item.reviewId);
    if (!line) return item;
    return {
      ...item,
      unitPrice: line.unitPrice,
      lineTotal: line.lineTotal,
      isFree: line.isFree,
    };
  });
}

export function pricingPlanLabel(billingPlan) {
  return billingPlan === "subscriber"
    ? "Subscriber (Paid)"
    : "Free Tier (Unpaid)";
}

export function formatPricingBreakdownSummary(pricing) {
  if (!pricing) return "—";
  if (pricing.billingPlan === "subscriber") {
    const parts = [];
    if (pricing.freeReviewsApplied > 0) {
      parts.push(`${pricing.freeReviewsApplied} inkl.`);
    }
    if (pricing.paidReviewCount > 0) {
      parts.push(
        `${pricing.paidReviewCount} × ${formatEuro(pricing.pricePerReview)}`
      );
    }
    return parts.length ? parts.join(" · ") : "€0";
  }
  return `${pricing.reviewCount} × ${formatEuro(pricing.pricePerReview)}`;
}
